<template>
    <Paper class="single">
        <div class="single-list-detail">
            <el-row>
                <el-col :span="8">
                    <span>分公司 :</span> <span>{{detailData.companyName}}</span>
                </el-col>
                <el-col :span="8">
                    <span>服务平台 :</span><span>{{detailData.siteName}}</span>
                </el-col>
                <el-col :span="8">
                    <span>排单编号 :</span><span>{{detailData.lineCode}}</span>
                </el-col>
                <el-col :span="8">
                    <span>状态 :</span><span>{{detailData.lineStatusName}}</span>
                </el-col>
                <el-col :span="8">
                    <span>用时(秒) :</span><span>{{detailData.processingTime}}</span>
                </el-col>
                <el-col :span="8">
                    <span>开始时间 :</span><span>{{detailData.lineStartTime}}</span>
                </el-col>
                <el-col :span="8">
                    <span>结束时间 :</span><span>{{detailData.lineEndTime}}</span>
                </el-col>
                <el-col :span="8">
                    <span>订单数 :</span><span>{{detailData.totalOrderNum}}</span>
                </el-col>
                <el-col :span="8">
                    <span>车次数 :</span><span>{{detailData.lineNum}}</span>
                </el-col>
                <el-col :span="8">
                    <span>总里程 :</span><span>{{detailData.totalMileage}}</span>
                </el-col>
                <el-col :span="8">
                    <span>失败原因 :</span>
                        <el-tooltip class="item" effect="dark" :content="detailData.orderFailReason" placement="top">
                            <span>{{detailData.orderFailReason}}</span>
                        </el-tooltip>
                </el-col>
                <el-col :span="8">
                    <span>方数(m³) :</span><span>{{detailData.totalVolume}}</span>
                </el-col>
            </el-row>
        </div>
        <div class="table">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="订单" name="first">
                    <detail-table
                        :tableData="orderTableData"
                        :columnLists="comfig.orderLists"
                        >
                    </detail-table>
                </el-tab-pane>
                <el-tab-pane label="车次" name="second">
                     <detail-table
                        :tableData="lineTableData"
                        :columnLists="comfig.carLists"
                        >
                    </detail-table>
                </el-tab-pane>
            </el-tabs>
        </div>
    </Paper>
</template>
<script>import Paper from '@/components/core/paper/Paper';
import DetailTable from './DetailTable';
import comfig from './datailTableConfig';
import { getOrderList, getLineList } from '../../../../api/singleList';

export default {
    name: 'singleListDetail',
    components: { Paper, DetailTable },
    data() {
        return {
            comfig,
            activeName: 'first',
            orderTableData: [],
            lineTableData: [],
            columnLists: [],
            detailData: {
                siteName: '',
                companyName: '',
                lineCode: '',
                lineStatusName: '',
                processingTime: '',
                lineStartTime: '',
                lineEndTime: '',
                totalOrderNum: '',
                lineNum: '',
                totalMileage: '',
                orderFailReason: '',
                totalVolume: ''
            }
        };
    },
    methods: {
        // 获取订单明细
        getOrderLists() {
            getOrderList({ lineHeaderId: this.detailData.id, pageSize: 10000, pageNo: 1 }).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(item => {
                        item.restrictFlagName = +item.restrictFlag === 0 ? '否' : +item.restrictFlag === 1 ? '是' : '';
                    });
                    this.orderTableData = res.data.list;
                }
            });
        },
        // 获取车次明细
        getLineLists() {
            getLineList({ lineHeaderId: this.detailData.id, pageSize: 10000, pageNo: 1 }).then(res => {
                if (res && +res.code === 0) {
                    this.lineTableData = res.data.list;
                }
            });
        }
    },
    created () {
        this.detailData = this.$route.query.rowData;
        this.getOrderLists();
        this.getLineLists();
    },
    activated () {
        this.detailData = this.$route.query.rowData;
        this.getOrderLists();
        this.getLineLists();
    }
};
</script>
<style lang="less">
.single{
    height: calc(100vh - 60px);
    overflow-y: scroll;
}
.single-list-detail{
    color: #666666;
    font-size: 14px;
    .el-row {
            border: 1px solid #dcdfe6;
            border-right: none;
            border-bottom: none;
            background-color: #f5f7fa;
            .el-col {
                display: flex;
                justify-content: space-around;
                height: 44px;
                border-bottom: 1px solid #dcdfe6;
                border-right: 1px solid #dcdfe6;
                line-height: 44px;
                margin-bottom: 0;
                padding-left: 12px;

                span:first-child {
                    flex: 4;
                    border-right: 1px solid #dcdfe6;
                }
                span:last-child {
                    flex: 5;
                    display: inline-block;
                    height: 100%;
                    background-color: #fff;
                    padding-left: 12px;
                    overflow: hidden;    /*   超出容器的部分影响  */
                    white-space: nowrap;   /*  文本不换行   */
                    text-overflow: ellipsis;   /*  超出容器的文本显示省略号  */
                }
            }
    }
}
.table{
        margin-top: 5px;
        padding-top: 5px;
}
</style>
